import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as $ from 'jquery' ; 
import { CustomDataService } from '../services/custom-data.service';

@Component({
  selector: 'show-tailer',
  templateUrl: './show-tailer.component.html',
  styleUrls: ['./show-tailer.component.css']
})
export class ShowTailerComponent implements OnInit {

   @Input("srcVideoURL")srcVideoURL:string ;
   @Input("showItem")showItem:boolean  = false   ; 
   @Output ()hideTrailer = new EventEmitter(); 
  constructor(private custom:CustomDataService) {}

  
  setShow()
  {
    this.hideTrailer.emit();
  }
  
  ngOnInit() {
    
    $(document).ready(function(){

      $(".fa-times").click(function(){
       
        $('.con-video').attr("src","");
        
      });
     

        });
    
  }
  

}
